import Coupon from '../coupons/coupon';
import Freight from '../freight/freight';
import FreightSelected from '../freight/freight-selected';
import Address from '../user/address';
import Utms from '../utm/utms';
import CheckoutPayment from './checkout-payment';
import ShippingAddress from './shipping-address';

export default class Checkout {
  public cartId?: number;
  public freightSelected?: FreightSelected;
  public payment?: CheckoutPayment;
  public addressDelivery?: ShippingAddress;
  public addressInvoicing?: ShippingAddress;
  public coupon?: Coupon;
  public utms?: Utms;

  constructor(
    cartId: number | undefined,
    freightSelected: FreightSelected | undefined,
    payment: CheckoutPayment,
    addressDelivery: Address,
    addressInvoicing: Address | null,
    sameAddressForInvoice: boolean,
    utms: Utms
  ) {
    this.cartId = cartId;
    this.freightSelected = freightSelected;
    if (this.freightSelected?.optionFreight === Freight.STORE_PICKUP) {
      this.freightSelected.freight = null;
    }
    this.payment = payment;
    this.addressDelivery = new ShippingAddress();
    this.addressDelivery.fromAddress(addressDelivery, sameAddressForInvoice);

    if (addressInvoicing) {
      this.addressInvoicing = new ShippingAddress();
      this.addressInvoicing.fromAddress(addressInvoicing, false);
    }

    this.utms = utms;
  }
}
